import ErrorBoundary from '@/components/ErrorBoundary';
import { DefaultComponent, StandaloneComponent } from '@/types/component';
import getConfig from 'modules/config';
import Script from 'next/script';
import { useEffect } from 'react';

export const StandaloneConsent: StandaloneComponent<{}> = () => {
  const consentVersion = `2.3.14${
    ['svenskdam', 'hant'].includes(`${process.env.OCELOT_SITE}`) ? `${process.env.OCELOT_SITE}` : ''
  }`;
  const consentPath = `/common/js/consent`;
  const componentVersion = '01';
  const cacheBuster = `v=${consentVersion}-${componentVersion}`;
  const oneTrustId = getConfig('cmp.onetrust_id') as string;

  useEffect(() => {
    window.onetrustId = oneTrustId;
  }, []);

  if (process.env.CONSENT_DISABLED === 'true') {
    return null;
  }

  return (
    <ErrorBoundary>
      {/* CMP - OneTrust consent */}
      <Script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        strategy="beforeInteractive"
        data-document-language="true"
        data-domain-script={`${oneTrustId}`}
      />

      {/* Aller consent library */}
      <Script src={`${consentPath}/consent-${consentVersion}.js`} strategy="beforeInteractive" />
    </ErrorBoundary>
  );
};

export const standalone = StandaloneConsent;

const DefaultConsent: DefaultComponent = () => {
  return <StandaloneConsent />;
};

export default DefaultConsent;
